import React, { useState, useEffect } from "react";
import Layout from "../../Layout";
import Container from "../../components/Container";
import { FaTooth, FaEdit } from "react-icons/fa";
import Modal from "../../components/Modals/Modal";
import { Button, Input, MenuSelect } from "../../components/Form";
import { FaSave } from "react-icons/fa";
import { MdKeyboardArrowDown } from "react-icons/md";
import { useAppSelector } from '../../store';

import { viewLabMaterial, editLabMaterial } from "../../api/labMaterial";
import { useParams } from "react-router-dom";
import { toast } from 'react-toastify';
import Loader from "../../components/Loader";

function SingleMaterial() {
	const userData = useAppSelector((state) => state.userData);

	const [modal, setModal] = useState(false);
	const [dropdown, setDropdown] = useState(false);
	const data = [{ name: "ml" }, { name: "dl" }, { name: "g" }, { name: "#" }];

	const [labMaterial, setLabMaterial] = useState([]);
	const [name, setName] = useState("");
	const [code, setCode] = useState("");
	const [unit, setUnit] = useState("#");
	const [description, setDescription] = useState("");
	const [pageLoader, setPageLoader] = useState(true);
	const [loading, setLoading] = useState(false);
	const { id } = useParams();

	useEffect(() => {
		console.log(userData)
		const fetchData = async () => {
			const res = await viewLabMaterial({ materialId: id });
			setLabMaterial(res);
			setName(res?.name);
			setCode(res?.code);
			setUnit(res?.unit);
			setDescription(res?.description);
			setPageLoader(false);
			console.log(res);
		};

		if (userData?.user?.defaultLabId) {
			fetchData();
		}
	}, [userData, modal]);

	const handleSave = async () => {
		if (!name.trim()) {
			toast.error("Name is required");
			return;
		}

		const data = {
			materialId: labMaterial?._id,
			name: name,
			code: code,
			unit: unit,
			description: description,
		};

		setLoading(true);
		const response = await editLabMaterial(data);
		if (response) {
			setLoading(false);
			setModal(false);
			setName("");
			setCode("");
			setUnit("#");
			setDescription("");
		}
		setLoading(false);
	}

	return (
		<Layout>
			{
				pageLoader ? <Loader /> :
					<>
						<Container className="flex flex-col min-w-80 max-w-80 px-5 py-10 items-center bg-white/60 rounded-lg">
							<FaTooth size={44} className="text-gray-900/85" />
							<div className="text-lg my-1">{labMaterial?.name}</div>
							<div className="text-xs mt-1">Code:</div>
							<div className="text-xs mt-1">{labMaterial.code}</div>
							<div className="text-xs mt-2">Unit:</div>
							<div className="text-xs">{labMaterial.unit}</div>
							<div className="text-xs mt-2">Description</div>
							<div className="text-xs mb-4 text-center">{labMaterial.description}</div>
							<Button
								className="flex max-w-fit px-4 items-center"
								Icon={() => <FaEdit size={16} />}
								label={"Edit"}
								onClick={() => setModal(true)}
							/>
						</Container>
						<Modal isOpen={modal} closeModal={() => setModal(false)} title={"Edit Material"}>
							<Input label={"Name *"} placeholder={"Name"} color={true} value={name} onChange={(e) => setName(e.target.value)} />
							<Input label={"Code "} placeholder={"Code"} color={true} value={code} onChange={(e) => setCode(e.target.value)} />
							<div className="" onClick={() => setDropdown(!dropdown)}>
								<MenuSelect
									className={"my-2"}
									datas={data}
									onClick={(e) => { setUnit(e.name); }}
									isMenuOpen={dropdown}
									setIsMenuOpen={setDropdown}
									staticMode>
									<div className="flex flex-1 flex-col">
										<div className="flex flex-1 w-full">Unit *</div>
										<div className="flex flex-1 justify-between">
											<span>{unit}</span>
											<MdKeyboardArrowDown className="text-lg" />
										</div>
									</div>
								</MenuSelect>
							</div>
							<Input label={"Description"} placeholder={"Description"} color={true} value={description} onChange={(e) => setDescription(e.target.value)} />
							<Button className={"my-4"} label={"Save"} Icon={FaSave} onClick={handleSave} loading={loading} />
						</Modal>
					</>
			}
		</Layout>
	);
}

export default SingleMaterial;
